import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { mcpServersUrl, resolveMcpAuth } from './mcp-auth';

export default async function get_all_available_mcp_api_call(
  isPending?: boolean
) {
  const auth = resolveMcpAuth();

  const requestInfo: RequestInfo = {
    url: `${mcpServersUrl(auth)}${isPending ? '?is_pending=true' : ''}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: auth.authorization,
    },
  };

  const actionType = 'GET_AVAILABLE_MCP_SERVER_LIST';
  const customMsg = 'Available MCP Server Data Loaded Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  // asyncHandler returns null/undefined on 401/network error — guard the deref
  // and return an empty list so callers never receive `false`/undefined (which
  // throws in the consumer's .map/.forEach and freezes the page on a skeleton).
  if (!response?.success) {
    return [];
  }
  if (res.actionType === actionType && response.success === true) {
    if (response.data === null) {
      return [];
    } else {
      return response?.data;
    }
  }
}
